/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  Address,
  AddressFromJSON,
  AddressToJSON,
  ProgramStatus,
  ProgramType,
} from './'

/**
 *
 * @export
 * @interface ProgramCreate
 */
export interface ProgramCreate {
  /**
   *
   * @type ProgramType
   * @memberof ProgramCreate
   */
  type: ProgramType
  /**
   *
   * @type ProgramStatus
   * @memberof ProgramCreate
   */
  status: ProgramStatus
  /**
   * The hideFromPublicSearch prevents a program from being displayed on the marketing site.
   * @type boolean
   * @memberof ProgramCreate
   */
  hideFromPublicSearch?: boolean
  /**
   * The contractual model name for a tutor configured at program level.
   * @type string
   * @memberof ProgramCreate
   */
  tutorModel?: string
  /**
   * The starting date for the program's first semester in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramCreate
   */
  semesterOneStartDate: Date
  /**
   * The starting date for the program's second semester in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramCreate
   */
  semesterTwoStartDate: Date
  /**
   * The starting time for the program using ISO standard 24 hour format: `hh:mm`.
   * @type string
   * @memberof ProgramCreate
   */
  startTime: string
  /**
   * The ending time for the program using ISO standard 24 hour format: `hh:mm`.
   * @type string
   * @memberof ProgramCreate
   */
  endTime: string
  /**
   * The day of the week the program is available. Where 1 is Monday and 7 is Sunday
   * @type number
   * @memberof ProgramCreate
   */
  dayOfTheWeek: number
  /**
   * Unique identifier of the actor for the Program Director
   * @type number
   * @memberof ProgramCreate
   */
  directorActorId?: number
  /**
   * Unique identifier of the actor for the program's assigned tutor.
   * @type number
   * @memberof ProgramCreate
   */
  tutorActorId?: number
  /**
   * Unique identifiers of the actors for the program's assigned tutors.
   * @type {Array<number>}
   * @memberof ProgramCreate
   */
  tutorActorIds?: Array<number>
  /**
   * The maximum number of students allowed in a program.
   * @type number
   * @memberof ProgramCreate
   */
  capacity?: number
  /**
   * Program application fees.
   * @type string
   * @memberof ProgramCreate
   */
  applicationFee?: string
  /**
   * Program enrollment fees.
   * @type string
   * @memberof ProgramCreate
   */
  enrollmentFee?: string
  /**
   * Program supply first student fee.
   * @type string
   * @memberof ProgramCreate
   */
  supplyFeeFirstStudent?: string
  /**
   * Program supply additional students fees.
   * @type string
   * @memberof ProgramCreate
   */
  supplyFeeAdditionalStudent?: string
  /**
   * Program tuition fees.
   * @type string
   * @memberof ProgramCreate
   */
  tuition?: string
  /**
   * Program local first student fee.
   * @type string
   * @memberof ProgramCreate
   */
  localFeeFirstStudent?: string
  /**
   * Program facility first student fee.
   * @type string
   * @memberof ProgramCreate
   */
  facilityFeeFirstStudent?: string
  /**
   * Any other miscellaneous program First student fee.
   * @type string
   * @memberof ProgramCreate
   */
  miscFeeFirstStudent?: string
  /**
   * Program local Additional students fees.
   * @type string
   * @memberof ProgramCreate
   */
  localFeeAdditionalStudent?: string
  /**
   * Program facility Additional students fees.
   * @type string
   * @memberof ProgramCreate
   */
  facilityFeeAdditionalStudent?: string
  /**
   * Any other miscellaneous program Additional student fees.
   * @type string
   * @memberof ProgramCreate
   */
  miscFeeAdditionalStudent?: string
  /**
   * **DEPRECATED** Any other miscellaneous program fees.
   * @type string
   * @memberof ProgramCreate
   */
  miscFee2?: string
  /**
   * The percentage of fees given to the tutor. Must be a number from 0 to 100.
   * @type string
   * @memberof ProgramCreate
   */
  subLicensedTutorPercentage?: string
  /**
   * A discount to subsequent application fees when more than one student applies to the same program.
   * @type string
   * @memberof ProgramCreate
   */
  multiStudentApplicationDiscount?: string
  /**
   * The fee a director pays CC Home Office per student for the first semester for the first student in their program.
   * @type string
   * @memberof ProgramCreate
   */
  semesterOneLicensingFee?: string
  /**
   * The fee a director pays CC Home Office per student for the first semester for the second+ students in their program.
   * @type string
   * @memberof ProgramCreate
   */
  discountSemesterOneLicensingFee?: string
  /**
   * The fee a director pays CC Home Office per student for the second semester for the first student in their program..
   * @type string
   * @memberof ProgramCreate
   */
  semesterTwoLicensingFee?: string
  /**
   * The fee a director pays CC Home Office per student for the second semester for the second+ students in their program.
   * @type string
   * @memberof ProgramCreate
   */
  discountSemesterTwoLicensingFee?: string
  /**
   * The invitation fee per student invitation
   * @type string
   * @memberof ProgramCreate
   */
  invitationFee?: string
  /**
   * The discount invitation fee per applied to invitation fee
   * @type string
   * @memberof ProgramCreate
   */
  discountInvitationFee?: string
  /**
   * LCD program tutor semester one first students licensing fees
   * @type string
   * @memberof ProgramCreate
   */
  tutorS1FirstStudentLicFee?: string
  /**
   * LCD program tutor semester two first students licensing fees.
   * @type string
   * @memberof ProgramCreate
   */
  tutorS2FirstStudentLicFee?: string
  /**
   * LCD program tutor semester one additional students licensing fees.
   * @type string
   * @memberof ProgramCreate
   */
  tutorS1AdditionalStudentLicFee?: string
  /**
   * LCD program tutor semester two additional students licensing fees.
   * @type string
   * @memberof ProgramCreate
   */
  tutorS2AdditionalStudentLicFee?: string
  /**
   * The percentage of fees given to the LCD program tutor. Must be a number from 0 to 100.
   * @type string
   * @memberof ProgramCreate
   */
  lcdTutorPercentage?: string
  /**
   * Id of the community in which this program is offered.
   * @type number
   * @memberof ProgramCreate
   */
  communityId: number
  /**
   *
   * @type Address
   * @memberof ProgramCreate
   */
  address: Address
  /**
   * Phone number for the director of the program.
   * @type string
   * @memberof ProgramCreate
   */
  directorPhone?: string
}

export function ProgramCreateFromJSON(json: any): ProgramCreate {
  return ProgramCreateFromJSONTyped(json, false)
}

export function ProgramCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProgramCreate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    type: json['type'],
    status: json['status'],
    hideFromPublicSearch: !exists(json, 'hideFromPublicSearch')
      ? undefined
      : json['hideFromPublicSearch'],
    tutorModel: !exists(json, 'tutorModel') ? undefined : json['tutorModel'],
    semesterOneStartDate: new Date(json['semesterOneStartDate']),
    semesterTwoStartDate: new Date(json['semesterTwoStartDate']),
    startTime: json['startTime'],
    endTime: json['endTime'],
    dayOfTheWeek: json['dayOfTheWeek'],
    directorActorId: !exists(json, 'directorActorId')
      ? undefined
      : json['directorActorId'],
    tutorActorId: !exists(json, 'tutorActorId')
      ? undefined
      : json['tutorActorId'],
    tutorActorIds: !exists(json, 'tutorActorIds')
      ? undefined
      : json['tutorActorIds'],
    capacity: !exists(json, 'capacity') ? undefined : json['capacity'],
    applicationFee: !exists(json, 'applicationFee')
      ? undefined
      : json['applicationFee'],
    enrollmentFee: !exists(json, 'enrollmentFee')
      ? undefined
      : json['enrollmentFee'],
    supplyFeeFirstStudent: !exists(json, 'supplyFeeFirstStudent')
      ? undefined
      : json['supplyFeeFirstStudent'],
    supplyFeeAdditionalStudent: !exists(json, 'supplyFeeAdditionalStudent')
      ? undefined
      : json['supplyFeeAdditionalStudent'],
    tuition: !exists(json, 'tuition') ? undefined : json['tuition'],
    localFeeFirstStudent: !exists(json, 'localFeeFirstStudent')
      ? undefined
      : json['localFeeFirstStudent'],
    facilityFeeFirstStudent: !exists(json, 'facilityFeeFirstStudent')
      ? undefined
      : json['facilityFeeFirstStudent'],
    miscFeeFirstStudent: !exists(json, 'miscFeeFirstStudent')
      ? undefined
      : json['miscFeeFirstStudent'],
    localFeeAdditionalStudent: !exists(json, 'localFeeAdditionalStudent')
      ? undefined
      : json['localFeeAdditionalStudent'],
    facilityFeeAdditionalStudent: !exists(json, 'facilityFeeAdditionalStudent')
      ? undefined
      : json['facilityFeeAdditionalStudent'],
    miscFeeAdditionalStudent: !exists(json, 'miscFeeAdditionalStudent')
      ? undefined
      : json['miscFeeAdditionalStudent'],
    miscFee2: !exists(json, 'miscFee2') ? undefined : json['miscFee2'],
    subLicensedTutorPercentage: !exists(json, 'subLicensedTutorPercentage')
      ? undefined
      : json['subLicensedTutorPercentage'],
    multiStudentApplicationDiscount: !exists(
      json,
      'multiStudentApplicationDiscount'
    )
      ? undefined
      : json['multiStudentApplicationDiscount'],
    semesterOneLicensingFee: !exists(json, 'semesterOneLicensingFee')
      ? undefined
      : json['semesterOneLicensingFee'],
    discountSemesterOneLicensingFee: !exists(
      json,
      'discountSemesterOneLicensingFee'
    )
      ? undefined
      : json['discountSemesterOneLicensingFee'],
    semesterTwoLicensingFee: !exists(json, 'semesterTwoLicensingFee')
      ? undefined
      : json['semesterTwoLicensingFee'],
    discountSemesterTwoLicensingFee: !exists(
      json,
      'discountSemesterTwoLicensingFee'
    )
      ? undefined
      : json['discountSemesterTwoLicensingFee'],
    invitationFee: !exists(json, 'invitationFee')
      ? undefined
      : json['invitationFee'],
    discountInvitationFee: !exists(json, 'discountInvitationFee')
      ? undefined
      : json['discountInvitationFee'],
    tutorS1FirstStudentLicFee: !exists(json, 'tutorS1FirstStudentLicFee')
      ? undefined
      : json['tutorS1FirstStudentLicFee'],
    tutorS2FirstStudentLicFee: !exists(json, 'tutorS2FirstStudentLicFee')
      ? undefined
      : json['tutorS2FirstStudentLicFee'],
    tutorS1AdditionalStudentLicFee: !exists(
      json,
      'tutorS1AdditionalStudentLicFee'
    )
      ? undefined
      : json['tutorS1AdditionalStudentLicFee'],
    tutorS2AdditionalStudentLicFee: !exists(
      json,
      'tutorS2AdditionalStudentLicFee'
    )
      ? undefined
      : json['tutorS2AdditionalStudentLicFee'],
    lcdTutorPercentage: !exists(json, 'lcdTutorPercentage')
      ? undefined
      : json['lcdTutorPercentage'],
    communityId: json['communityId'],
    address: AddressFromJSON(json['address']),
    directorPhone: !exists(json, 'directorPhone')
      ? undefined
      : json['directorPhone'],
  }
}

export function ProgramCreateToJSON(value?: ProgramCreate | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    type: value.type,
    status: value.status,
    hideFromPublicSearch: value.hideFromPublicSearch,
    tutorModel: value.tutorModel,
    semesterOneStartDate: value.semesterOneStartDate
      .toISOString()
      .substr(0, 10),
    semesterTwoStartDate: value.semesterTwoStartDate
      .toISOString()
      .substr(0, 10),
    startTime: value.startTime,
    endTime: value.endTime,
    dayOfTheWeek: value.dayOfTheWeek,
    directorActorId: value.directorActorId,
    tutorActorId: value.tutorActorId,
    tutorActorIds: value.tutorActorIds,
    capacity: value.capacity,
    applicationFee: value.applicationFee,
    enrollmentFee: value.enrollmentFee,
    supplyFeeFirstStudent: value.supplyFeeFirstStudent,
    supplyFeeAdditionalStudent: value.supplyFeeAdditionalStudent,
    tuition: value.tuition,
    localFeeFirstStudent: value.localFeeFirstStudent,
    facilityFeeFirstStudent: value.facilityFeeFirstStudent,
    miscFeeFirstStudent: value.miscFeeFirstStudent,
    localFeeAdditionalStudent: value.localFeeAdditionalStudent,
    facilityFeeAdditionalStudent: value.facilityFeeAdditionalStudent,
    miscFeeAdditionalStudent: value.miscFeeAdditionalStudent,
    miscFee2: value.miscFee2,
    subLicensedTutorPercentage: value.subLicensedTutorPercentage,
    multiStudentApplicationDiscount: value.multiStudentApplicationDiscount,
    semesterOneLicensingFee: value.semesterOneLicensingFee,
    discountSemesterOneLicensingFee: value.discountSemesterOneLicensingFee,
    semesterTwoLicensingFee: value.semesterTwoLicensingFee,
    discountSemesterTwoLicensingFee: value.discountSemesterTwoLicensingFee,
    invitationFee: value.invitationFee,
    discountInvitationFee: value.discountInvitationFee,
    tutorS1FirstStudentLicFee: value.tutorS1FirstStudentLicFee,
    tutorS2FirstStudentLicFee: value.tutorS2FirstStudentLicFee,
    tutorS1AdditionalStudentLicFee: value.tutorS1AdditionalStudentLicFee,
    tutorS2AdditionalStudentLicFee: value.tutorS2AdditionalStudentLicFee,
    lcdTutorPercentage: value.lcdTutorPercentage,
    communityId: value.communityId,
    address: AddressToJSON(value.address),
    directorPhone: value.directorPhone,
  }
}
